import { Marca } from '../componentes/Marca.tsx';
import { BotaoTema } from '../componentes/Tema.tsx';
import { Aviso, Botao, Cartao, Etiqueta, Icone } from '../componentes/ui/index.ts';
import { useSessao } from '../lib/sessao.tsx';

/**
 * Onde caem as contas que existem mas ainda não têm acesso. Sem esta tela a
 * pessoa levaria um 403 e acharia que errou a senha.
 */
export function Aguardando() {
  const { usuario, sair, recarregar } = useSessao();

  const conteudo = {
    pendente: {
      etiqueta: 'Aguardando',
      titulo: 'Cadastro em análise',
      texto:
        'Sua conta foi criada, mas o acesso ao painel só é liberado depois que um administrador aprovar e definir seu nível de permissão. Avisaremos por e-mail assim que isso acontecer.',
      tipo: 'info' as const,
    },
    rejeitado: {
      etiqueta: 'Recusado',
      titulo: 'Acesso não aprovado',
      texto:
        usuario?.motivoRejeicao ??
        'Seu pedido de acesso ao painel não foi aprovado. Se acredita que houve engano, fale com a liderança do ministério.',
      tipo: 'alerta' as const,
    },
    revogado: {
      etiqueta: 'Revogado',
      titulo: 'Acesso encerrado',
      texto:
        'Seu acesso ao painel foi revogado por um administrador. Fale com a liderança se precisar dele de volta.',
      tipo: 'alerta' as const,
    },
  };

  const estado = conteudo[usuario?.status as keyof typeof conteudo] ?? conteudo.pendente;

  return (
    <div className="container container-form" style={{ paddingBlock: 'var(--gap-7)' }}>
      <header className="linha linha-entre" style={{ marginBottom: 'var(--gap-7)' }}>
        <Marca subtitulo="Painel" />
        <BotaoTema />
      </header>

      <main id="conteudo" className="pilha-5">
        <div className="pilha-3">
          <Etiqueta>{estado.etiqueta}</Etiqueta>
          <h1>{estado.titulo}</h1>
        </div>

        <Cartao>
          <div className="pilha">
            <Aviso tipo={estado.tipo}>{estado.texto}</Aviso>

            <p className="texto-fraco">
              Conectado como <strong>{usuario?.email}</strong>
            </p>

            <div className="linha">
              {usuario?.status === 'pendente' && (
                <Botao variante="vazado" onClick={() => void recarregar()}>
                  Verificar de novo
                </Botao>
              )}
              <Botao variante="fantasma" onClick={() => void sair()} icone={<Icone.Sair />}>
                Sair
              </Botao>
            </div>
          </div>
        </Cartao>
      </main>
    </div>
  );
}
